import { Typography } from "@circle-react-uikit/Typography";

export interface ResultTypeBadgeProps {
  label: string;
}

export const ResultTypeBadge = ({ label }: ResultTypeBadgeProps) => (
  <span className="border-primary bg-primary flex rounded border px-1.5 py-[1px]">
    <Typography.LabelXs color="text-default">{label}</Typography.LabelXs>
  </span>
);
